module.exports = __webpack_public_path__ + "img/咒骂.08e65162.png";